/**
 * The "Environmental Health Certifications" section of the Certification & Compliance page
 * (`src/pages/why-ryerson/ryerson-commitment/certification-compliance/index.tsx`, its only
 * importer): LEED (text only), REACH (with a PDF letter) and Safety Data Sheets (a link to the
 * Environment, Health & Safety page). Copy is in `./EnvironmentalHealthCertsContent.tsx`.
 */
import React from "react";
import { Media } from "@ryerson/frontend.next";
import EnvironmentalHealthCertsDesktop from "./EnvironmentalHealthCertsDesktop";
import EnvironmentalHealthCertsMobile from "./EnvironmentalHealthCertsMobile";

/** Renders the section, mobile below `lg`. */
const EnvironmentalHealthCerts: React.FC = () => {
	return (
		<>
			<Media lessThan="lg">
				<EnvironmentalHealthCertsMobile />
			</Media>
			<Media greaterThanOrEqual="lg">
				<EnvironmentalHealthCertsDesktop />
			</Media>
		</>
	);
};

export default EnvironmentalHealthCerts;
